import React, { FunctionComponent, useEffect, useState } from "react";

import { bridge } from "@multiweb/reactCore/bridge";
const {
    addControlComponentVisibilityChangedListener,
    getControlComponentVisibility,
    removeControlComponentVisibilityChangedListener,
} = bridge;
import { bemClassNames, useInView } from "@multiweb/reactUtils";

export type VisibleHtmlElementProps = {
    /**
     * Identifikátor elementu, na který nastaví listenery na změnu viditelnosti.
     * Zpravidla by to měl být element uvnitř Itemu, aby item korektně reagoval na jeho změnu viditelnosti.
     */
    elementWithVisibilityChangeId?: string;
};

const className = bemClassNames("visible-html-element");

/** Komponenta obalující klasický GridLayoutItem listenery pro použití v connectoru. */
export const VisibleHtmlElement: FunctionComponent<VisibleHtmlElementProps> = ({
    elementWithVisibilityChangeId,
    children,
}) => {
    const [itemRef, inView] = useInView({ triggerOnce: true });
    const [visible, setVisible] = useState<boolean>(true);
    useEffect(() => {
        if (!inView || !elementWithVisibilityChangeId) {
            return undefined; // Dokud neni v DOMu nebo nemá id elementu, tak neinicializuje listenery.
        }
        function listener(_control: any, value: boolean) {
            setVisible(value);
        }
        // Při zobrazení nebo změně identifikátoru vnitřního elementu se nastavuje visibility podle vnitřního elementu.
        setVisible(getControlComponentVisibility(elementWithVisibilityChangeId));
        addControlComponentVisibilityChangedListener(elementWithVisibilityChangeId, listener);
        return () => {
            removeControlComponentVisibilityChangedListener(elementWithVisibilityChangeId, listener);
        };
    }, [inView, elementWithVisibilityChangeId]);

    return (
        <div ref={itemRef} className={className({ hidden: !visible })}>
            {children}
        </div>
    );
};
